import { SortOrder } from "@arelia-types/data-models";

export interface Campaign {
  id?: string;
  name: string;
  createdAt: string;
  scheduledAt?: string;
  fans: string[];
  text: string;
  lastSentAt?: string;
  lastSentCount?: number;
  isRegistrationCompleted: boolean;
  messageLimit: number;
  messageLimitCurrent: number;
}

export interface CampaignMessage {
  fanId: string;
  name: string;
  pending: number;
  failed: number;
  delivered: number;
  scheduled: number;
}

export enum CampaignSorting {
  createdDateAsc = "createdAtAsc",
  createdDateDesc = "createdAtDesc",
  nameAsc = "nameAsc",
  nameDesc = "nameDesc",
}

export type SortOrderMapType = {
  [key in CampaignSorting]: SortOrder;
}

export type SortValueGetterMapType = {
  [key in CampaignSorting]: (campaign: Campaign) => string | Date;
}